// extracted by mini-css-extract-plugin
export var legendIndicator = "_dq-1";
export var legendRight = "_dq-0";